import { useState } from "react";
import { createPortal } from "react-dom";
import { X } from "@phosphor-icons/react";
import { fileUrl } from "@/lib/api";

const COLORS = ["#007AFF", "#FF3B30", "#34C759", "#FF9500", "#AF52DE", "#5AC8FA"];

function initials(name) {
  if (!name) return "?";
  const parts = name.trim().split(/\s+/);
  return (parts[0][0] + (parts[1] ? parts[1][0] : "")).toUpperCase();
}

function colorFor(name) {
  let h = 0;
  for (let i = 0; i < (name || "").length; i++) h = (h * 31 + name.charCodeAt(i)) % COLORS.length;
  return COLORS[h];
}

export function Avatar({ name, path, size = 40, className = "", enlargeable = false }) {
  const src = fileUrl(path);
  const [open, setOpen] = useState(false);
  const style = { width: size, height: size };

  const openLightbox = (e) => {
    if (!src) return;
    e.stopPropagation();
    e.preventDefault();
    setOpen(true);
  };

  const lightbox = open && src
    ? createPortal(
        <div
          className="fixed inset-0 z-[100] bg-black/90 backdrop-blur-md flex items-center justify-center p-6 animate-fade-up"
          onClick={() => setOpen(false)}
          data-testid="avatar-lightbox"
        >
          <button
            onClick={(e) => { e.stopPropagation(); setOpen(false); }}
            className="absolute top-4 left-4 p-2.5 rounded-full bg-white/10 hover:bg-white/20 text-white transition-colors"
            aria-label="Close"
            data-testid="avatar-lightbox-close"
          >
            <X size={26} weight="bold" />
          </button>
          <img
            src={src}
            alt={name}
            onClick={(e) => e.stopPropagation()}
            className="max-w-[90vw] max-h-[78vh] rounded-xl object-contain border border-white/10 shadow-2xl"
          />
          {name && (
            <div className="absolute bottom-8 left-0 right-0 text-center text-white font-heading font-bold uppercase tracking-widest text-lg px-6">
              {name}
            </div>
          )}
        </div>,
        document.body
      )
    : null;

  if (src) {
    return (
      <>
        <img
          src={src}
          alt={name}
          style={style}
          onClick={enlargeable ? openLightbox : undefined}
          className={`rounded-md object-cover border border-border shrink-0 ${enlargeable ? "cursor-zoom-in" : ""} ${className}`}
        />
        {lightbox}
      </>
    );
  }
  return (
    <div
      style={{ ...style, backgroundColor: colorFor(name) }}
      className={`rounded-md flex items-center justify-center font-heading font-bold text-white shrink-0 ${className}`}
    >
      <span style={{ fontSize: size * 0.4 }}>{initials(name)}</span>
    </div>
  );
}
